var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDydx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.764 6L6.43 18h2.558l8.379-12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedDydx0)",
    d: "m9.257 6l2.452 3.536l-1.282 1.928L6.643 6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedDydx1)",
    d: "m15.013 18l-2.721-3.913l1.281-1.873L17.572 18z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedDydx0",
    x1: 10.878,
    x2: 18.631,
    y1: 7.647,
    y2: 16.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedDydx1",
    x1: 15.6,
    x2: 11.259,
    y1: 17.091,
    y2: 11.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6966FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6966FF",
    stopOpacity: 0.36
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDydx);
export default __webpack_public_path__ + "static/media/dydx.3ffd940ecbd75805bcf0b59f282a44c3.svg";
export { ForwardRef as ReactComponent };